<template>
  <div class="w-100 my-5">
    <div class="box-white d-flex flex-column">
      <div class="row w-100 mt-5 vertical-center">
        <span class="col-sm-2 m-1 font-bold font-12 alpha-07">Event ID</span>
        <input class="col-sm m-1 font-12" v-model="eventId" />
      </div>
      <div class="my-5 d-flex justify-content-end">
        <v-btn class="mx-5 button-normal" small @click="getDrinkOrderListTask" :disabled="!eventId">
          <span>Get Drink Order List</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { httpsCallable } from 'firebase/functions';
import { firestore, functions } from '../../../main';
import { collection, query, getDocs, where, orderBy, limit, doc, getDoc } from 'firebase/firestore';
import { showLoading, getDecimalFormat } from '../../../functions';

export default {
  name: 'SetDrinkSoldQuantityMap',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    }
  },
  data() {
    return {
      eventId: '',
      list: []
    }
  },
  mounted() {
    if (window.location.hostname !== 'localhost') {
      this.$router.push('/');
    }
  },
  methods: {
    getDecimalFormat,
    getDrinkOrderListTask() {
      if (!this.eventId) {
        this.$toast.info('Invalid event ID.');
        return;
      }
      //console.log(`[getDrinkOrderListTask] Starting: eventId=${this.eventId}`);
      const loader = showLoading(this);
      const q = query(collection(firestore, 'drinkOrder'), where('eventId', '==', this.eventId), where('employeeName', '!=', ''));
      getDocs(q).then(querySnapshot => {
        loader.hide();
        //console.log(`[getDrinkOrderListTask] Fetched ${querySnapshot.docs.length} drink orders`);
        const drinkMap = {};
        
        // Build map: drinkId -> quantityMap(employeeName -> totalQuantity)
        querySnapshot.forEach(doc => {
          const data = doc.data();
          if (!data.completedAt) {
            return; // Skip completed orders
          }
          const drinks = data.drinks || [];
          const employeeName = data.employeeName;
          drinks.forEach(drink => {
            if (!drinkMap[drink.drinkId]) {
              drinkMap[drink.drinkId] = {
                drinkId: drink.drinkId,
                quantityMap: {}
              };
            }
            if (!drinkMap[drink.drinkId].quantityMap[employeeName]) {
              drinkMap[drink.drinkId].quantityMap[employeeName] = 0;
            }
            drinkMap[drink.drinkId].quantityMap[employeeName] += drink.quantity;
          });
        });
        
        // Convert map to array
        this.list = Object.values(drinkMap);
        //console.log(`[getDrinkOrderListTask] Built drink map with ${this.list.length} unique drinks`);
        this.getDrinkInfoTask(0);
      }).catch(error => {
        loader.hide();
        //console.error(`[getDrinkOrderListTask] Error: eventId=${this.eventId}, error=`, error);
        this.$toast.error('Unexpected error occurs - ' + error.message);
      });
    },
    getDrinkInfoTask(index) {
      if (index >= this.list.length) {
        //console.log('All drinks processed successfully');
        return; // All drinks processed
      }
      const item = this.list[index];
      //console.log(`Processing drink ${index + 1}/${this.list.length}: drinkId=${item.drinkId}`);
      const { drinkId, quantityMap } = item;
      getDoc(doc(firestore, 'drink', drinkId)).then(docSnapshot => {
        if (!docSnapshot.exists()) {
          //console.error(`[getDrinkInfoTask] Drink not found: drinkId=${drinkId}`);
          this.$toast.error('Drink not found.');
          return;
        }
        const drinkData = docSnapshot.data();
        const updatedSoldQuantityMap = { ...drinkData.soldQuantityMap || {} };
        
        // Merge quantityMap into soldQuantityMap
        Object.keys(quantityMap).forEach(employeeName => {
          if (!updatedSoldQuantityMap[employeeName]) {
            updatedSoldQuantityMap[employeeName] = 0;
          }
          updatedSoldQuantityMap[employeeName] += quantityMap[employeeName];
        });
        
        const updateInfo = {
          soldQuantityMap: updatedSoldQuantityMap
        };
        this.updateDocumentTask(index, drinkId, updateInfo);
      }).catch(error => {
        //console.error(`[getDrinkInfoTask] Error fetching drink: drinkId=${drinkId}, error=`, error);
        this.$toast.error('Error fetching drink info: ' + error.message);
      });
    },
    updateDocumentTask(index, drinkId, updateInfo) {
      //console.log(`[updateDocumentTask] Starting: drinkId=${drinkId}, updateInfo=`, updateInfo);
      if (!drinkId) {
        //console.error(`[updateDocumentTask] Invalid drinkId`);
        this.$toast.info('Invalid Drink Id.');
        return;
      }
      const params = {
        functionName: 'updateDocumentInfo',
        collection: 'drink',
        id: drinkId,
        updateInfo: updateInfo
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      //console.log(`[updateDocumentTask] Calling cloud function with params:`, params);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          //console.log(`[updateDocumentTask] Update successful: drinkId=${drinkId}`);
          this.getDrinkInfoTask(index + 1); // Process next drink
        } else {
          //console.error(`[updateDocumentTask] Update failed: drinkId=${drinkId}, response=${response.data}`);
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        //console.error(`[updateDocumentTask] Error: drinkId=${drinkId}, error=`, error);
        this.$toast.error(error.code + ', ' + error.message);
      });
    },
  }
};
</script>